import axios from 'axios';
import qs from 'qs'
import Auth from './auth.js';

// 请求超时时间
axios.defaults.timeout = 90000;

//axios.defaults.withCredentials = true

// post请求头
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';
// put请求头
axios.defaults.headers.put['Content-Type'] = 'application/json;charset=UTF-8';
// 请求拦截器
axios.interceptors.request.use(
    config => {
        // 每次发送请求之前判断是否存在token，如果存在，则统一在http请求的header都加上token，不用每次请求都手动添加了
        const token = Auth.getAccessToken();
        if (token) {  // 判断是否存在token，如果存在的话，则每个http header都加上token
            config.headers['HC-SMP-Authorization'] = token;
        }
        return config;
    },
    error => {
        return Promise.error(error);
    }
);

// 响应拦截器
axios.interceptors.response.use(
    response => {
        if (response.status === 200) {
            return Promise.resolve(response);
        } else {
            return Promise.reject(response);
        }
    },
    // 服务器状态码不是200的情况
    error => {
        if (error) {
            console.log(error)
        }
        return Promise.reject(error);
    }
);

export function httpGet(url, params) {
    return new Promise((resolve, reject) => {
        axios.get(url, { params: params }).then(res => {
            resolve(res);
        }).catch(err => {
            reject(err);
        })
    });
}

export function httpDownload(url, params) {
    return new Promise((resolve, reject) => {
        axios.get(url, { params: params, responseType: 'blob', timeout: 60000 }).then(res => {
            resolve(res);
        }).catch(err => {
            reject(err);
        })
    });
}

export function httpPostForm(url, params) {
    let qsStr = qs.stringify(params)
    return new Promise((resolve, reject) => {
        axios.post(`${url}?${qsStr}`, qsStr).then(res => {
            resolve(res);
        }).catch(err => {
            reject(err);
        })
    });
}

export function httpPost(url, params) {
    return new Promise((resolve, reject) => {
        axios.post(url, params).then(res => {
            resolve(res);
        }).catch(err => {
            reject(err);
        })
    });
}

export function httpDelete(url, params) {
    return new Promise((resolve, reject) => {
        axios.delete(url, { data: params }).then(res => {
            resolve(res)
        }).catch(err => {
            reject(err);
        })
    });
}

export function httpPut(url, params) {
    return new Promise((resolve, reject) => {
        axios.put(url, params).then(res => {
            resolve(res)
        }).catch(err => {
            reject(err);
        })
    });
}

export default axios;